module.exports = __webpack_public_path__ + "img/bgr-sparks.f30943c5.svg";